import { Skeleton, Stack, Text, TextLink, VisuallyHidden } from '@ads-core/components';
import { ArrowRightIcon } from '@ads-core/icons';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { capitalizeLocationName } from 'src/utils';
import { IntegrationApiFeaturesCongestionReportsContractsDataCongestionReport as CongestionReportsData } from '@alliander-fe/api';
import { encodeBaseUrl } from 'src/utils/urlFormat/encodeBaseUrl';
import { FALLBACK_STATUS } from '../CongestionReportHero/constant/constants';

type TableRowData = {
  fields: Record<string, React.ReactNode>;
  verticalAlign?: 'top' | 'bottom' | 'middle';
};

export const tableFields = (
  fields: CongestionReportsData[] | undefined,
  detailWildcardPage: LinkFieldValue | undefined
): TableRowData[] => {
  const mappedFields = fields?.length
    ? fields.map((item) => {
        return {
          fields: {
            installation: item.name ? (
              <Stack>
                <Text size="description">{`Station ${capitalizeLocationName(item.name)}`}</Text>
              </Stack>
            ) : null,
            congestion: (
              <Stack>
                <Text size="description">{item.congestionType}</Text>
              </Stack>
            ),
            status: (
              <Stack>
                <Text size="description">
                  {item.status?.length ? item.status : FALLBACK_STATUS}
                </Text>
              </Stack>
            ),
            link: detailWildcardPage?.href ? (
              <Stack alignX={{ initial: 'start', md: 'end' }} isFullWidth>
                <TextLink
                  href={encodeBaseUrl(
                    `${detailWildcardPage?.href}/${item.name}/${item.congestionType}`
                  )}
                  afterIcon={<ArrowRightIcon size="xs" />}
                >
                  Bekijk details
                  <VisuallyHidden>Verdeelstation {item.name}</VisuallyHidden>
                </TextLink>
              </Stack>
            ) : null,
          },
          verticalAlign: 'top' as const,
        };
      })
    : [];

  return mappedFields;
};

export const tableFieldsLoading = (limit: number) => {
  return [...Array(limit)].map(() => ({
    fields: {
      installation: <Skeleton.Item height="20px" width="100%" />,
      congestion: <Skeleton.Item height="20px" width="100%" />,
      status: <Skeleton.Item height="20px" width="100%" />,
      link: (
        <Stack direction="row" gap={2} isFullWidth>
          <Skeleton.Item height="20px" width="100%" />
          <ArrowRightIcon size="xs" />
        </Stack>
      ),
    },
  }));
};
